import { Routes } from '@angular/router';
import { ButtonPage } from './button-page/button-page';
import { ComponentLabPage } from './component-lab-page';
import { ContentCardPage } from './content-card-page/content-card-page';

export const componentLabRoutes: Routes = [
  {
    path: '',
    component: ComponentLabPage,
  },
  {
    path: 'button',
    component: ButtonPage,
  },
  {
    path: 'content-card',
    component: ContentCardPage,
  },
];
